import _defineProperty from "@babel/runtime/helpers/defineProperty";
import COLORS from '@tekion/tekion-styles-next/scss/variables.scss';
import { SORT_OVERRIDE_INDEX } from '@tekion/tekion-base/constants/sortOrder';

/**
 * showInSelectedValues is used for not showing Select/Deselect All label on selected values.
 */
export var ALL_OPTION = _defineProperty({
  label: __('Select All'),
  value: 'ALL',
  showInSelectedValues: false,
  styles: {
    borderBottom: "0.1rem solid ".concat(COLORS.glitter)
  }
}, SORT_OVERRIDE_INDEX, 0);